/* eslint-disable no-console */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  wrenchIcons: ({ color, size }) => {
    const fontSize = size
      ? { fontSize: theme.iconSize[size] }
      : { fontSize: 'inherit' };

    const chosenColor =
      theme.typeColor[color] || theme.semanticColor[color] || 'currentColor';

    return {
      fontFamily: theme.fontFamily.base,
      ...fontSize,
      '-webkit-font-smoothing': 'antialiased',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      margin: '0 auto',
      verticalAlign: 'middle',
      textAlign: 'center',
      fill: chosenColor,
    };
  },
}));

export default useStyles;
